import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-50 text-primary-700 border-primary-200',
    accent: 'bg-accent-50 text-accent-700 border-accent-200',
    secondary: 'bg-secondary-50 text-secondary-700 border-secondary-200',
  };

  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">内容分类</h2>
          <p className="section-subtitle">按分类浏览吃瓜内容，快速找到你感兴趣的领域</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg ${colorMap[item.color] || colorMap.primary} border flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-2 leading-relaxed">
                {item.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}